import React, { useState } from 'react';
import { ServiceNoteCreate } from '../../../models/ServiceNoteModel';

interface ServiceNoteFormProps {
  onSubmit: (payload: ServiceNoteCreate) => void;
  onCancel?: () => void;
  loading?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
}

const ServiceNoteForm: React.FC<ServiceNoteFormProps> = ({
  onSubmit,
  onCancel,
  loading = false,
  submitLabel = 'Guardar nota',
  cancelLabel = 'Cancelar',
}) => {
  const [text, setText] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const trimmed = text.trim();
    if (!trimmed) {
      setError('Escribe el texto de la nota.');
      return;
    }
    onSubmit({ text: trimmed });
  };

  return (
    <form className="service-note-form" onSubmit={handleSubmit}>
      <div className="service-note-form-field">
        <label htmlFor="service-note-text">Nota</label>
        <textarea
          id="service-note-text"
          className="service-note-form-textarea"
          placeholder="Escribe una observación o comentario del servicio..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={4}
          disabled={loading}
        />
        {error && <span className="service-note-form-error">{error}</span>}
      </div>
      <div className="service-note-form-actions">
        {onCancel && (
          <button
            type="button"
            className="service-note-form-btn service-note-form-btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
        )}
        <button
          type="submit"
          className="service-note-form-btn service-note-form-btn-submit"
          disabled={loading || !text.trim()}
        >
          {loading ? 'Guardando...' : submitLabel}
        </button>
      </div>
    </form>
  );
};

export default ServiceNoteForm;
